import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { resetQuiz } from 'redux/reducers/quiz'
import { Button, CircularProgress, Icons } from 'components/Antifraude'
import validateStageOnboarding from 'utils/validateStage'
import { roles } from 'utils/constants/roles'
import { FailContainer } from './styles'

export default (props) => {
  const { history } = props
  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)

  const dispatch = useDispatch()

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  function handleStart() {
    history.replace(`/quiz`)
  }

  useEffect(() => {
    dispatch(resetQuiz())
    validateStageOnboarding(token, history, roles.QUIZ, handleLoading)
  }, [])

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <FailContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h1>Responder Quiz</h1>

      <div className="hint">
        <Icons icon="light" />
        <p>Leia atentamente as questões e responda antes do tempo terminar.</p>
      </div>
      <Button onClick={handleStart}>
        Iniciar Quiz
      </Button>
    </FailContainer>
  )
}
